import React, { createContext, useContext, useMemo, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { getTheme } from './theme';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Home from './pages/Home';
import ProjectDetail from './pages/ProjectDetail';
import WorkerLedger from './pages/WorkerLedger';
import FindWorkers from './pages/FindWorkers';

const ThemeModeContext = createContext({ mode: 'dark', toggle: () => {} });
export const useThemeMode = () => useContext(ThemeModeContext);

const Guarded = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/" element={<Guarded><Home /></Guarded>} />
    <Route path="/projects/:id" element={<Guarded><ProjectDetail /></Guarded>} />
    <Route path="/workers/:id" element={<Guarded><WorkerLedger /></Guarded>} />
    <Route path="/find-workers" element={<Guarded><FindWorkers /></Guarded>} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

const App = () => {
  const [mode, setMode] = useState(localStorage.getItem('bp-theme') || 'dark');
  const theme = useMemo(() => getTheme(mode), [mode]);

  const toggle = () => {
    const next = mode === 'dark' ? 'light' : 'dark';
    localStorage.setItem('bp-theme', next);
    setMode(next);
  };

  return (
    <ThemeModeContext.Provider value={{ mode, toggle }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
};

export default App;
